// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBod8iQ--Dx7y1vui3-FDf07jvI7vd1410",
    authDomain: "clients-ef364.firebaseapp.com",
    databaseURL: "https://clients-ef364.firebaseio.com",
    projectId: "clients-ef364",
    storageBucket: "clients-ef364.appspot.com",
    messagingSenderId: "464583651594"
  }
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
